/**
 * 申請要求処理
 */
// tslint:disable-next-line:no-namespace
export namespace ApplicationProcessType {
    /** 新規申請 */
    export const NEW = '1';
    /** 申請書修正 */
    export const CORRECT = '2';
    /** 申請書確認 */
    export const CHECK = '3';
    /** 変更申請 */
    export const CHANGE = '4';
    /** 継続申請 */
    export const CONTINUE = '5';
    // 2023/12/12 [2023L-06] add start
    /** 申請取消 */
    export const CANCEL = '8';
    // 2023/12/12 [2023L-06] add end
    //2024/01/16 [2023L-14] add start
    /** 申請履歴 */
    export const HISTORY = '9';
    //2024/01/16 [2023L-14] add end
}
